(() => {
  'use strict';
  const viewer = document.querySelector('#VmImageViewer');
  if (!viewer || typeof viewer.showModal !== 'function') return;
  document.documentElement.classList.add('vm-image-viewer-ready');
  const image = viewer.querySelector('[data-viewer-image]');
  const caption = viewer.querySelector('[data-image-caption]');
  const count = viewer.querySelector('[data-image-count]');
  const prev = viewer.querySelector('[data-image-prev]');
  const next = viewer.querySelector('[data-image-next]');
  const close = viewer.querySelector('[data-image-close]');
  const description = '.vm-product-photo-gallery, .vm-product-description-section, .product__description';
  let items = [], index = 0, opener = null, previousOverflow = '';
  const isImageLink = link => {
    if (!link) return false;
    try { return /\.(?:avif|webp|png|jpe?g|gif)$/i.test(new URL(link.href, location.href).pathname); }
    catch (_) { return false; }
  };
  const source = img => {
    const link = img.closest('a');
    let src = isImageLink(link) ? link.href : (img.currentSrc || img.src);
    try {
      const url = new URL(src, location.href);
      if (url.hostname === 'cdn.shopify.com' || url.pathname.includes('/cdn/shop/')) {
        url.searchParams.set('width', '1400');
        src = url.href;
      }
    } catch (_) { /* Retain the rendered image source. */ }
    return { src, alt: img.alt || '', caption: img.closest('figure')?.querySelector('figcaption')?.textContent.trim() || img.alt || '' };
  };
  const render = () => {
    const item = items[index];
    image.src = item.src;
    image.alt = item.alt;
    caption.textContent = item.caption;
    count.textContent = items.length > 1 ? (index + 1) + ' / ' + items.length : '';
    prev.hidden = next.hidden = items.length < 2;
  };
  const show = (images, selected, trigger) => {
    items = images.map(source);
    index = Math.max(0, images.indexOf(selected));
    opener = trigger;
    render();
    previousOverflow = document.body.style.overflow;
    viewer.showModal();
    document.body.style.overflow = 'hidden';
    close.focus({ preventScroll: true });
  };
  const step = delta => { index = (index + delta + items.length) % items.length; render(); };
  close.addEventListener('click', () => viewer.close());
  prev.addEventListener('click', () => step(-1));
  next.addEventListener('click', () => step(1));
  viewer.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  viewer.addEventListener('click', event => {
    if (event.target !== viewer) return;
    const box = viewer.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) viewer.close();
  });
  viewer.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.closest('#VmImageViewer')) return;
    const media = target.closest('.product__modal-opener--image');
    if (media) {
      const img = media.querySelector('img');
      if (!img) return;
      const gallery = media.closest('media-gallery') || media.parentElement;
      const images = Array.from(gallery.querySelectorAll('.product__modal-opener--image img'));
      event.preventDefault(); event.stopImmediatePropagation();
      show(images, img, media.querySelector('button') || media);
      return;
    }
    const region = target.closest(description);
    if (!region) return;
    const link = target.closest('a');
    const img = target.closest('img') || (isImageLink(link) ? link.querySelector('img') : null);
    if (!img || (link && !isImageLink(link))) return;
    const images = Array.from(region.querySelectorAll('img')).filter(item => !item.closest('a') || isImageLink(item.closest('a')));
    event.preventDefault(); event.stopImmediatePropagation();
    show(images, img, link || img);
  }, true);
  const prepare = root => {
    root.querySelectorAll(description).forEach(region => {
      region.querySelectorAll('img').forEach(img => {
        const link = img.closest('a');
        if (link && !isImageLink(link)) return;
        img.dataset.vmViewable = 'true';
        if (link) {
          link.removeAttribute('target');
          link.setAttribute('aria-haspopup', 'dialog');
        } else if (!img.hasAttribute('tabindex')) {
          img.tabIndex = 0; img.setAttribute('role', 'button'); img.setAttribute('aria-haspopup', 'dialog');
          img.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); img.click(); }
          });
        }
      });
    });
  };
  prepare(document);
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; prepare(document); });
  }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
})();
